import axios from "axios";
import { useEffect, useState } from "react";
const IMAGE_BASE_URL = 'https://akhuwat.org.pk';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || window.location.origin;
const config = {
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // Include cookies
};

export const useFetchContent = (shortNames) => {
    
    
    const [apiData, setApiData] = useState([]);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      const fetchDropdownData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/v1/content/short/${shortNames}`
          );
  
          const contentData = response.data?.data || "Default Content";
          setApiData(contentData);
        } catch (error) {
          console.error("Error fetching content data:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchDropdownData();
    }, [shortNames]);
  
    return { apiData, loading };
  };



  //fetch slider content




  export const useFetchSections = (sections) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      const fetchValues = async () => {
        try {
          setLoading(true); // Start loading
  
          // Fetch data using axios
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/faq/content/${sections}`
          );
          const programsData = response.data.data; // Assuming the data is in 'data' field
  
          // Store the data
          setData(programsData);
  
          setLoading(false); // Set loading to false after fetching
        } catch (error) {
          console.error("Error fetching values:", error);
          setLoading(false); // Set loading to false even if an error occurs
        }
      };
  
      if (sections) {
        fetchValues(); // Request data for the passed `sections`
      }
    }, [sections]); // Run the effect when `sections` change
  
    return { loading, data };
  };


  //fetch all sections against a page



  
  export const useFetchSectionsbyPage = (page) => {
    const [loading, setLoading] = useState(false);
    const [sections, setSections] = useState([]);
  
    useEffect(() => {
      const fetchValues = async () => {
        try {
          setLoading(true); // Start loading
  
          // Fetch data using axios
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/all/sections/${page}`
          );
          const programsData = response.data.data; // Assuming the data is in 'data' field
  
          // Store the data
          setSections(programsData);
  
          setLoading(false); // Set loading to false after fetching
        } catch (error) {
          console.error("Error fetching values:", error);
          setLoading(false); // Set loading to false even if an error occurs
        }
      };
  
      if (page) {
        fetchValues(); // Request data for the passed `sections`
      }
    }, [page]); // Run the effect when `sections` change
  
    return { loading, sections };
  };






export const useFetchSeo = (pageId) => {
  const [loading, setLoading] = useState(false);
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/v1/all/seo/tags/${pageId}`
        );

        setSeo(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching SEO:", error);
        setLoading(false);
      }
    };

    if (pageId) {
      fetchSeo();
    }
  }, [pageId]);

  return { loading, seo };
};


  /**
 * Converts full server-side image path to client-accessible URL.
 * Example: '/var/www/uploads/images/x.jpg' → 'https://akhuwat.org.pk/uploads/images/x.jpg'
 */
export const getImagePath = (fullPath) => {
  if (!fullPath) return '';
  const relativePath = fullPath.replace('/var/www', '');
  return encodeURI(`${IMAGE_BASE_URL}${relativePath}`);
};
